
import UniformSysConfigApi from './src/UniformSysConfig'
import UniformConfigApi from './src/UniformConfig'


let apis = {
   UniformSysConfigApi,
   UniformConfigApi
};

export default apis;
